<template>
  <div class="container order-change-container">
    <div class="base-info">
      <div class="order-base-header"><strong>改升交易编码:</strong>{{ this.changeNo }}</div>
      <div class="order-gray-table-outer">
        <table class="order-gray-table">
          <tr>
            <td>
              <span class="_info-t">升舱状态：</span>
              <span class="_info-m r">{{ detail.statusCn }}</span>
            </td>
            <td>
              <span class="_info-t">PNR（系统编号）：</span>
              <span class="_info-m">{{ detail.pnrNo }}</span>

            </td>
            <td>
              <span class="_info-t">补差价：</span>
              <span class="_info-m">{{ detail.changeAmount || '--' }}元</span>

            </td>
            <td>
              <span class="_info-t">变更手续费：</span>
              <span class="_info-m">{{ detail.serviceAmount }}元</span>
            </td>
          </tr>
          <tr>
            <!-- <td>
              <span class="_info-t">支付手续费：</span>
              <span class="_info-m">{{ detail.payChargeAmount }}元</span>
            </td> -->
            <td>
              <span class="_info-t">支付总金额：</span>
              <span class="_info-m r-large">{{ detail.totalAmount }}元</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="pass-info">
      <template v-for="(pass, passIndex) in detail.travelers">
      <div class="pass-item"
           :key="passIndex"
           v-if="pass.newFlightSegments.length"
      >
        <div class="order-primary-header">
          <l8-icon class="l8-icon" type="icon-lvke"/>
          <span class="header-label">{{ pass.fullName }}</span>
          <span class="header-msg">
            <span>{{ pass.certificateType | certificateType }}：{{ pass.certificateNo | codeMask({offset: 4, length: 10}) }}</span>
            <span>联系电话：{{ pass.mobile | codeMask }}</span>
          </span>
        </div>
        <div class="change-seg-table-warp">
          <table class="order-default-table change-seg-table">
            <thead>
            <tr>
              <td>行程</td>
              <td>航班号</td>
              <td>起飞时间</td>
              <td>到达时间</td>
              <td>舱位</td>
              <td>产品名称</td>
              <td>票号</td>
              <td>客票状态</td>
              <td>票面价</td>
              <td>民航发展基金</td>
              <td>燃油</td>
              <td>总票价</td>
            </tr>
            </thead>
            <tbody>
            <template v-for="(newSeg, newSegIdx) in pass.newFlightSegments">
              <tr :key="'newSeg' + newSegIdx">
                <td class="seg-line"><i class="seg-tip"><span>新</span></i>{{ newSeg.departureAirPortName }} - {{ newSeg.arrivalAirPortName}}</td>
                <td>{{ newSeg.airlineName }} {{ newSeg.flightNo }}</td>
                <td>{{ newSeg.departureDate }} {{ newSeg.departureTime }}</td>
                <td>{{ newSeg.arrivalDate }} {{ newSeg.arrivalTime }}</td>
                <td>{{ newSeg.cabinCode }}/{{ newSeg.cabinRebate | discount }}</td>
                <td>{{ newSeg.product.productName }}</td>
                <td>{{ newSeg.ticketNo ? ticketCode + '-' + newSeg.ticketNo : '--' }}</td>
                <td>{{ newSeg.ticketStatus | ticketStatus }}</td>
                <td>{{ newSeg.product.netFare || '--' }}元</td>
                <td>{{ newSeg.product.airportTax || '--' }}元</td>
                <td>{{ newSeg.product.fuelTax || '--' }}元</td>
                <td>{{ newSeg.product.totalAmount }}元</td>
              </tr>
            </template>
            <template v-for="(oldSeg, oldSegIdx) in pass.oldFlightSegments">
              <tr :key="'oldSeg' + oldSegIdx">
                <td class="seg-line"><i class="seg-tip seg-old"><span>旧</span></i>{{ oldSeg.departureAirPortName }} - {{ oldSeg.arrivalAirPortName}}</td>
                <td>{{ oldSeg.airlineName }} {{ oldSeg.flightNo }}</td>
                <td>{{ oldSeg.departureDate }} {{ oldSeg.departureTime }}</td>
                <td>{{ oldSeg.arrivalDate }} {{ oldSeg.arrivalTime }}</td>
                <td>{{ oldSeg.cabinCode }}/{{ oldSeg.cabinRebate | discount }}</td>
                <td>{{ oldSeg.product.productName }}</td>
                <td>{{ oldSeg.ticketNo ? ticketCode + '-' + oldSeg.ticketNo : '--' }}</td>
                <td>{{ oldSeg.ticketStatus | ticketStatus }}</td>
                <td>{{ oldSeg.product.netFare || '--' }}元</td>
                <td>{{ oldSeg.product.airportTax || '--' }}元</td>
                <td>{{ oldSeg.product.fuelTax || '--' }}元</td>
                <td>{{ oldSeg.product.totalAmount }}元</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      </template>
    </div>
    <div class="change-notice" v-if="changeTips" v-html="changeTips"></div>
    <div class="order-action-row">
      <a-button type="primary" v-if="showPayBtn" @click="changePayHandler">在线支付</a-button>
      <a-button type="default" v-if="showCancelBtn" :loading="changeCancelLoading" @click="changeCancelHandler">取消升舱改期</a-button>
      <template v-if="userType === 'CARRIER' && detail.status === 'PF'">
        <a-button type="primary" :loading="submitting" @click="confirmOrderHandler">补出票</a-button>
        <!-- <a-button type="primary" :loading="submitting" @click="newSegConfirmHandler">新航段补出票</a-button> -->
        <!-- <a-button type="primary" :loading="submitting" @click="updateFlightTimeHandler">航班时刻更新</a-button> -->
      </template>
    </div>
    <!--支付弹窗-->
    <a-modal
      title="请选择支付方式"
      v-model="payModVisible"
      wrapClassName="order-modal pay-modal"
      :okText="'支付'"
      :cancelText="'取消'"
      :closable="false"
      :width="880"
      :confirmLoading="payingLoading"
      @ok="payApplyOk"
    >
      <PayBox
        ref="payBox"
        :payExtend="{
          filter: payFilter
        }"
        :default-active-key="payActiveKey"
        @paying="payingHandler"
        @paid="payDoneHandler"
      />
    </a-modal>
    <!--支付提示弹窗-->
    <a-modal
      title="系统提示"
      v-model="payNoticeVisible"
      :closable="false"
      class="mod-l8-alert-model"
      centered
    >
      <template slot="footer">
        <a-button
          key="error"
          type="primary"
          @click="PayErrorHandler"
        >
          支付遇到问题
        </a-button>
        <a-button
          key="submit"
          type="primary"
          @click="PayOkHandler"
        >
          已完成付款
        </a-button>
      </template>
      <h1>请您在新打开的网上银行页面上完成付款</h1>
      <p>请检查浏览器是否拦截弹窗</p>
      <p>付款完成前请不要关闭此窗口</p>
      <p>完成付款后请根据您的情况点击下面的按钮</p>
    </a-modal>
  </div>
</template>

<script>
import queryString from 'query-string'
import { detailV1, cancelV1, confirmOrderV1, newSeg, refresh } from '@/apis/change'
import { certificateType, ticketStatus } from '@/filters/order'
import { userTypeMap } from '@/dicts/member'
import getAppInfo from '@/utils/from'

import '@/components/l8-icon'
import '@/assets/css/l8-model.less'
import '@/assets/css/l8-order-common.less'

import PayBox from '@/components/pay-box'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

export default {
  data () {
    return {
      detail: {},
      orderId: '',
      changeId: '',
      changeNo: '',
      payModVisible: false,
      payingLoading: false,
      showPayBtn: false,
      showCancelBtn: false,

      changeCancelLoading: false,
      // 支付过滤
      payFilter: [],
      payActiveKey: '1',
      // 支付成功弹窗
      payNoticeVisible: false,

      userType: '',
      submitting: false,
      airline: window.__MICRO_ROOT__?.airline,
      changeTips: '',
      ticketCode: getAppInfo()?.ticketCode
    }
  },
  provide () {
    return {
      getOrderId: () => this.orderId
    }
  },
  created: function () {
    let query = queryString.parse(location.search)

    this.orderId = query.orderId
    this.changeId = query.changeId

    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      this.userType = userTypeMap[userInfo.userType]
    }

    this.fetchChangeDetail()
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { content } = res?.changeTips
          this.changeTips = content || ''
        })
      } catch (err) {}
    },
    fetchChangeDetail: async function () {
      const { airline, changeId } = this

      try {
        const { isCharterFlight, detail } = await detailV1({
          alineCode: airline,
          changeId
        })

        if (isCharterFlight) {
          this.payActiveKey = '0'
          this.payFilter = [{ bankId: 'YEEPAY' }]
        }

        this.updateChangeDetail(detail)
      } catch (err) {
        this.$message.error(err.message || '订单改升失败，请稍后再试')
      }
    },
    updateChangeDetail (detail) {
      this.detail = detail
      this.changeNo = detail.changeNo

      this.updateActions(detail.status)
    },
    updateActions (status) {
      switch (status) {
        case 'WP': // 等待支付
          this.showPayBtn = true
          this.showCancelBtn = true
          break
        case 'PF': // 已出票
          this.showPayBtn = false
          this.showCancelBtn = false
          break
        case 'HP': // 支付未出票
          this.showPayBtn = false
          this.showCancelBtn = false
          break
        case 'XX': // 已取消
          this.showPayBtn = false
          this.showCancelBtn = false
          break
        case 'WF': // 等待确认乘客
          this.showPayBtn = false
          this.showCancelBtn = true
          break
        default :
          this.showPayBtn = false
          this.showCancelBtn = false
      }
    },
    changePayHandler () {
      this.payModVisible = true
    },
    payApplyOk () {
      this.$refs['payBox'].doPay({
        orderId: this.changeId,
        orderNo: this.changeNo,
        amount: this.detail.totalAmount,
        orderType: 'CHANGE',
        returnUrl: '/micro/main/order/change/status',
        extraCommonParam: `changeId:${this.changeId}|orderId:${this.orderId}`
      })
    },
    payingHandler () {
      this.payingLoading = true
    },
    payDoneHandler (bank, status) {
      this.payingLoading = false
      this.payModVisible = false
      this.payNoticeVisible = true
    },
    PayErrorHandler () {
      this.payNoticeVisible = false
    },
    PayOkHandler () {
      this.payNoticeVisible = false
      this.fetchChangeDetail()
    },
    async changeCancelHandler () {
      this.changeCancelLoading = true
      const { airline, changeId } = this

      try {
        await cancelV1({
          alineCode: airline,
          changeId
        })

        this.changeCancelLoading = false

        this.$message.success('取消改升成功', () => {
          window.location.reload()
        })
      } catch (err) {
        this.changeCancelLoading = false

        this.$message.error(err.message || '取消改升失败，请稍后再试')
      }
    },
    confirmOrderHandler () {
      this.submitting = true

      this.$modal.confirm({
        title: '提示',
        content: '确定补出票？',
        cancelText: '取消',
        okText: '确认',
        onOk: async () => {
          const { airline, changeId } = this

          try {
            const data = await confirmOrderV1({
              alineCode: airline,
              changeId
            })

            this.submitting = false
            this.$message.success(data)
          } catch (err) {
            this.submitting = false
            this.$message.error(err.message || '补出票失败，请稍后再试')
          }
        },
        onCancel: () => {
          this.submitting = false
        }
      })
    },
    newSegConfirmHandler () {
      this.submitting = true

      this.$modal.confirm({
        title: '提示',
        content: '确定新航段补出票？',
        cancelText: '取消',
        okText: '确认',
        onOk: async () => {
          const { airline, changeId } = this

          try {
            const data = await newSeg({
              alineCode: airline,
              changeId
            })

            this.submitting = false
            this.$message.success(data)
          } catch (err) {
            this.submitting = false
            this.$message.error(err.message || '新航段补出票失败，请稍后再试')
          }
        },
        onCancel: () => {
          this.submitting = false
        }
      })
    },
    updateFlightTimeHandler () {
      this.submitting = true

      this.$modal.confirm({
        title: '提示',
        content: '确定更新航班时刻？',
        cancelText: '取消',
        okText: '确认',
        onOk: async () => {
          const { airline, changeId } = this

          try {
            const data = await refresh({
              alineCode: airline,
              changeId
            })

            this.submitting = false
            this.$message.success(data)
          } catch (err) {
            this.submitting = false
            this.$message.error(err.message || '航班时刻更新失败，请稍后再试')
          }
        },
        onCancel: () => {
          this.submitting = false
        }
      })
    }
  },
  components: {
    PayBox
  },
  filters: {
    certificateType,
    ticketStatus,
    discount (val) {
      const value = parseFloat(val)

      if (isNaN(parseFloat(value))) {
        return '-'
      }

      return value >= 1 ? '全价' : `${(value * 10).toFixed(1)}折`
    }
  }
}
</script>

<style lang="less">
  .base-info {
    margin-top: 50px;
  }

  .pass-info {
    margin-top: 50px;
  }

  .pass-item {
    margin-top: 30px;
  }

  .change-seg-table {

    &.order-default-table tbody tr td {
      padding: 14px 10px;
    }

    &.order-default-table tbody tr td:first-child {
      padding-left: 30px;
    }

    .seg-line {
      position: relative;
    }

    .seg-tip {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      color: #fff;
      text-decoration: none;

      span {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        font-style: normal;
        margin: 3px;
        font-size: 10px;
      }

      &:before {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-top: 30px solid red;
        border-right: 30px solid transparent;
      }

      &.seg-old {
        &:before {
          border-top: 30px solid #808080;
        }
      }
    }
  }

  .change-notice {
    margin-top: 16px;
  }

  /*订单弹窗样式*/
  .order-modal {
    .ant-modal-title {
      margin: 0;
      font-size: 18px;
      line-height: 22px;
      font-weight: bold;
      color: #fff;
    }
    .ant-modal-content {
      position: relative;
      background-color: #fff;
      border: 0;
      border-radius: 0;
      background-clip: padding-box;
    }
    .ant-modal-header {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 16px 24px;
      border-radius: 0;
      background: @primary-color;
      color: #fff;
    }
    .ant-modal-body {
      padding: 24px;
      font-size: 12px;
      line-height: 1.5;
      word-wrap: break-word;
    }
    .ant-modal-footer {
      border-top: 0;
      padding: 0 16px 40px;
      text-align: center;
      border-radius: 0;
    }

    &.pay-modal {
      .ant-modal-body {
        padding: 0;
      }

      .ant-modal-footer {
        border-top: 0;
        padding: 16px;
        text-align: right;
        border-radius: 0;
        background: #f5f5f5;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .change-seg-table-warp {
      overflow-x: scroll;
    }
  }

</style>
